import React, {Component} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import Router from './Router';
import {USER_SUCCESS, USER_FAILED, USER_NO_PERMISSION} from '../../redux/actions/UserActions'
import {fetchUserDataIfNeeded} from '../../redux/actions/UserActions'
import {fetchUtilsDataIfNeeded} from '../../redux/actions/UtilsActions'
import LoadingProgress from '../../components/LoadingProgress'
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import RouterSignUp from './RouterSignUp';
import {fetchCustomeraDataIfNeeded} from "../../redux/actions/CustomersActions";
import {fetchSalesDataIfNeeded} from "../../redux/actions/SalesActions";

class App extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            loaded: true
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchUserDataIfNeeded());
        this.props.dispatch(fetchUtilsDataIfNeeded());
        this.props.dispatch(fetchCustomeraDataIfNeeded({}));
        this.props.dispatch(fetchSalesDataIfNeeded());
    }

    render() {
        const loaded = this.state.loaded && !this.props.userData.loading;

        let isManager = false;

        if (this.props.userData && this.props.userData.data && this.props.userData.data.isManager) {
            isManager = true;
        }

        let isAdmin = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin) {
            isAdmin = true;
        }

        return (
            <div>
                {!loaded && <div className={`load${this.state.loading ? '' : ' loaded'}`}>
                    <LoadingProgress/>
                </div>
                }

                {loaded && this.props.status !== USER_NO_PERMISSION &&
                <div>
                    <Router isManager={isManager} isAdmin={isAdmin} hasError={this.props.status === USER_FAILED} userData={this.props.userData}/>
                </div>
                }

                {loaded && this.props.status === USER_NO_PERMISSION &&
                <RouterSignUp/>
                }

            </div>
        );
    }
}

export default withRouter(connect(state => {
    return {
        userData: state.userData,
        status: state.userData.status
    }
})(App));
